// Server-side pont that we are using to override
// Hardcoded for now since it's not deployed eyt
export var DefaultSettingPont = 4194304;
//# sourceMappingURL=constants.js.map